// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/images/login/collapse_arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simpleDropdownContainer {
  width: 100%;
  display: block;
  margin: 10px 0;
  position: relative;
}
.simpleDropdownContainer .selectedDropdown:before {
  width: 12px;
  height: 12px;
  color: #6a6b6c;
  position: absolute;
  top: -3px;
  right: 8px;
  padding: 10px;
  font-size: 14px;
  display: block;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  z-index: 100;
}
.simpleDropdownContainer.dropdownExpand .selectedDropdown:before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.selectedDropdown {
  background-color: #fff;
  border: 1px solid #9e9ea2;
  width: 100%;
  height: 35px;
  cursor: pointer;
  padding: 5px 10px;
  z-index: 101;
  position: relative;
  background-color: white;
  border: 3px solid grey;
  border-radius: 6px;
}
.simpleDropdownContainer.dropdownExpand .selectedDropdown {
  border-color: #049fd9;
}
.simpleDropdownList {
  display: none;
  width: 100%;
  position: absolute;
  top: 38px;
  max-height: 500px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
  z-index: 103;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  padding: 5px 5px;
  outline: none;
}
.simpleDropdownContainer.dropdownExpand .simpleDropdownList {
  display: block;
  background-color: #fff;
  border-radius: 6px;
  /* border-color: #049fd9 */
}
.simpleDropdownContainer .eachElement {
  display: block;
  padding: 12px;
  font-size: 13px;
  color: #909090;
  font-family: "ciscoSansRegular";
  background-color: #fff;
  cursor: pointer;
}
.simpleDropdownContainer .eachElement:hover {
  color: #666;
  background-color: rgba(57, 57, 59, 0.1);
}
.dropdownFilterOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.1);
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/login/dropdown-simple.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,cAAc;EACd,gDAA+D;EAC/D,YAAY;AACd;AACA;EACE,gDAA+D;AACjE;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,0CAA0C;AAC5C","sourcesContent":[".simpleDropdownContainer {\n  width: 100%;\n  display: block;\n  margin: 10px 0;\n  position: relative;\n}\n.simpleDropdownContainer .selectedDropdown:before {\n  width: 12px;\n  height: 12px;\n  color: #6a6b6c;\n  position: absolute;\n  top: -3px;\n  right: 8px;\n  padding: 10px;\n  font-size: 14px;\n  display: block;\n  content: url(\"../../../assets/images/login/collapse_arrow.svg\");\n  z-index: 100;\n}\n.simpleDropdownContainer.dropdownExpand .selectedDropdown:before {\n  content: url(\"../../../assets/images/login/collapse_arrow.svg\");\n}\n.selectedDropdown {\n  background-color: #fff;\n  border: 1px solid #9e9ea2;\n  width: 100%;\n  height: 35px;\n  cursor: pointer;\n  padding: 5px 10px;\n  z-index: 101;\n  position: relative;\n  background-color: white;\n  border: 3px solid grey;\n  border-radius: 6px;\n}\n.simpleDropdownContainer.dropdownExpand .selectedDropdown {\n  border-color: #049fd9;\n}\n.simpleDropdownList {\n  display: none;\n  width: 100%;\n  position: absolute;\n  top: 38px;\n  max-height: 500px;\n  overflow-y: auto;\n  padding: 0;\n  margin: 0;\n  z-index: 103;\n  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);\n  padding: 5px 5px;\n  outline: none;\n}\n.simpleDropdownContainer.dropdownExpand .simpleDropdownList {\n  display: block;\n  background-color: #fff;\n  border-radius: 6px;\n  /* border-color: #049fd9 */\n}\n.simpleDropdownContainer .eachElement {\n  display: block;\n  padding: 12px;\n  font-size: 13px;\n  color: #909090;\n  font-family: \"ciscoSansRegular\";\n  background-color: #fff;\n  cursor: pointer;\n}\n.simpleDropdownContainer .eachElement:hover {\n  color: #666;\n  background-color: rgba(57, 57, 59, 0.1);\n}\n.dropdownFilterOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 100;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
